var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBdCake = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 4.75C8.00375 4.75 8.70833 4.0375 8.70833 3.16667C8.70833 2.86583 8.62917 2.58875 8.47875 2.35125L7.125 0L5.77125 2.35125C5.62083 2.58875 5.54167 2.86583 5.54167 3.16667C5.54167 4.0375 6.25417 4.75 7.125 4.75ZM10.7113 12.6033L9.91958 11.8117L9.06458 12.6587C8.03542 13.6879 6.23042 13.6958 5.19333 12.6587L4.34625 11.8117L3.48333 12.6587C2.96875 13.1733 2.28 13.4583 1.55167 13.4583C0.97375 13.4583 0.443333 13.2762 0 12.9754V17.4167H14.25V12.9754C13.6562 13.3792 12.8963 13.5692 12.0808 13.3871C11.5583 13.2762 11.0913 12.9833 10.7113 12.6033ZM11.875 7.125H7.91667V5.54167H6.33333V7.125H2.375C1.06083 7.125 0 8.18583 0 9.5V10.7192C0 11.5742 0.696667 12.2708 1.55167 12.2708C1.96333 12.2708 2.35917 12.1125 2.64417 11.8196L4.33833 10.1333L6.02458 11.8196C6.61042 12.4054 7.63167 12.4054 8.2175 11.8196L9.91167 10.1333L11.5979 11.8196C11.8908 12.1125 12.2788 12.2708 12.6904 12.2708C13.5454 12.2708 14.2421 11.5742 14.2421 10.7192V9.5C14.25 8.18583 13.1892 7.125 11.875 7.125Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBdCake, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bd_cake.86790ac4.svg";
export { ForwardRef as ReactComponent };